import MarkdownPreview from '@uiw/react-markdown-preview';

const source = `# Delete Account

**App link:** https://play.google.com/store/apps/details?id=com.ichoose.polltime&hl=en-US \n
**Developer Name:** Aravind P
To Delete your account, please follow steps below,
1. Send a mail to  aravindsiva1@gmail.com with following details.
\t1. **Subject:** Delete account
\t2. **Body:** Reason to delete. Your name and email address.

**Note**: Once your account is deleted, all the points/rewards which you earned will be lost.

Your account will be deleted in 7 days. 

`;

export default function DeleteAccount() {
  return <>
    <MarkdownPreview source={source}/>
  </>
}
